import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { useBuildMonarchURL } from '@bonusly/url';

import { useIsRecognize } from '../../../../hooks/use-is-recognize';

interface SmartLinkProps extends Omit<LinkProps, 'to'> {
	to: string;
}

export const SmartLink: FC<SmartLinkProps> = ({ to, ...rest }) => {
	const isRecognize = useIsRecognize();
	const isFullUrl = to.match(/^http/);
	const monarchURL = useBuildMonarchURL();

	// If we're on Recognize but only a path is provided then we need to append the base url
	// of Monarch to the path and perform a full HTTP request
	const linkTo = isRecognize && !isFullUrl ? monarchURL(to) : to;

	return <Link to={linkTo} reloadDocument={isRecognize} {...rest} />;
};
